import _Checkbox from "material-ui/Checkbox";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
class CheckboxInput extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "formatValue", value => {
      if (typeof value === 'string') {
        if (value.length === 0) {
          return false;
        }
        return value === 'true';
      }
      return value;
    });
    _defineProperty(this, "handleCheck", async () => {
      const {
        handleClick
      } = this.props;
      await this.handleChange();
      if (handleClick && typeof handleClick === 'function') {
        handleClick();
      }
    });
    _defineProperty(this, "handleChange", () => {
      const {
        input
      } = this.props;
      const {
        onChange,
        value
      } = input;
      onChange(!this.formatValue(value));
    });
    _defineProperty(this, "handleBlur", e => {
      e.preventDefault();
      const {
        input
      } = this.props;
      const {
        value
      } = e.target;
      const {
        onBlur
      } = input;
      onBlur(this.formatValue(value));
    });
  }
  render() {
    const {
      label,
      disabled,
      className,
      dataInput,
      input = {},
      iconStyle = {},
      labelStyle = {},
      labelPosition = 'right',
      checkedIcon,
      uncheckedIcon
    } = this.props;
    return /*#__PURE__*/React.createElement(_Checkbox, _extends({
      disabled: disabled
    }, input, {
      type: "checkbox",
      checked: this.formatValue(input.value),
      onCheck: this.handleCheck,
      onClick: this.handleChange,
      onBlur: this.handleBlur,
      name: input.name,
      label: label,
      className: className,
      "data-input": dataInput,
      labelPosition: labelPosition,
      labelStyle: labelStyle,
      iconStyle: iconStyle,
      uncheckedIcon: uncheckedIcon,
      checkedIcon: checkedIcon
    }));
  }
}
export { CheckboxInput };